import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputDateUI from '../../../widgets/form/InputDateUI'

const OrderUpdateModalUI = ({context, messageList, successMsg, errorList, setErrorList,
    // modes
    updateMode, submitted,
    // event handlers
    onSubmit, onCancelClick,
    // order name
    orderName, onOrderNameChange, orderNameError, setOrderNameError,
    // dueDate
    dueDate, onDueDateChange, dueDateError, setDueDateError,
  }) =>
  <ModalFormUI
    context={context}
    messageList={messageList}
    titleMessageKey='c_update_order'
    buttonMessageKey='c_update'
    cancelMessageKey='c_cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' name='orderName' required={true} maxLength={100}
      messageList={messageList} labelKey='c_order_name'
      value={orderName} onChange={onOrderNameChange}
      error={orderNameError} setError={setOrderNameError}
      autoFocus={true}
    />
    <InputDateUI context={context} name='dueDate'
      messageList={messageList} labelKey='c_due_date'
      selectedDateISO={dueDate} onChange={onDueDateChange}
      error={dueDateError} setError={setDueDateError}
    />
  </ModalFormUI>

export default OrderUpdateModalUI
